import React from 'react';
import SafeIcon from '../common/SafeIcon';

const defaultStats = [
  { value: "$126,000 / Year", label: "Average annual revenue lost due to missed calls.", icon: "DollarSign", color: "text-red-400" },
  { value: "62% Defect Instantly", label: "Callers dial a competitor if not answered immediately.", icon: "PhoneMissed", color: "text-orange-400" },
  { value: "85% Hang Up", label: "Voicemail is dead. Callers won't leave a message.", icon: "Voicemail", color: "text-amber-400" },
  { value: "41% Conversion", label: "Inbound phone leads convert 10x-15x higher than forms.", icon: "TrendingUp", color: "text-emerald-400" },
  { value: "35%–45% Volume", label: "Arrives after hours or during peak operational rush.", icon: "Clock", color: "text-blue-400" }
];

const Stats = ({ customStats }) => {
  const statsToShow = customStats || defaultStats;
  const gridCols = statsToShow.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-3 lg:grid-cols-5';

  return (
    <section id="problem" className="py-20 bg-slate-900/50 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {customStats ? "Industry Impact Data" : "The True Cost of Inaction"}
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Empirical metrics showing exactly why relying on voicemail or busy receptionists is destroying your bottom line.
          </p>
        </div>
        <div className={`grid grid-cols-1 ${gridCols} gap-6`}>
          {statsToShow.map((stat, idx) => (
            <div key={idx} className="bg-slate-800/50 border border-slate-700 rounded-2xl p-6 text-center hover:bg-slate-800 transition-colors">
              <div className="flex justify-center mb-4">
                <SafeIcon name={stat.icon} className={`text-3xl ${stat.color}`} />
              </div>
              <h3 className="text-xl font-bold text-white mb-2">{stat.value}</h3>
              <p className="text-sm text-slate-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;